var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 4.25,
    stroke: "#F34946",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.705 10L13.855 6.855C13.9492 6.76085 14.002 6.63315 14.002 6.5C14.002 6.36685 13.9492 6.23915 13.855 6.145C13.7608 6.05085 13.6332 5.99795 13.5 5.99795C13.3668 5.99795 13.2392 6.05085 13.145 6.145L10 9.295L6.855 6.145C6.76085 6.05085 6.63315 5.99795 6.5 5.99795C6.36685 5.99795 6.23915 6.05085 6.145 6.145C6.05085 6.23915 5.99795 6.36685 5.99795 6.5C5.99795 6.63315 6.05085 6.76085 6.145 6.855L9.295 10L6.145 13.145C6.09814 13.1915 6.06094 13.2468 6.03555 13.3077C6.01017 13.3686 5.9971 13.434 5.9971 13.5C5.9971 13.566 6.01017 13.6314 6.03555 13.6923C6.06094 13.7532 6.09814 13.8085 6.145 13.855C6.19148 13.9019 6.24678 13.9391 6.30771 13.9644C6.36864 13.9898 6.43399 14.0029 6.5 14.0029C6.56601 14.0029 6.63136 13.9898 6.69229 13.9644C6.75322 13.9391 6.80852 13.9019 6.855 13.855L10 10.705L13.145 13.855C13.1915 13.9019 13.2468 13.9391 13.3077 13.9644C13.3686 13.9898 13.434 14.0029 13.5 14.0029C13.566 14.0029 13.6314 13.9898 13.6923 13.9644C13.7532 13.9391 13.8085 13.9019 13.855 13.855C13.9019 13.8085 13.9391 13.7532 13.9644 13.6923C13.9898 13.6314 14.0029 13.566 14.0029 13.5C14.0029 13.434 13.9898 13.3686 13.9644 13.3077C13.9391 13.2468 13.9019 13.1915 13.855 13.145L10.705 10Z",
    fill: "#F34946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxExclamation);
export default __webpack_public_path__ + "static/media/CheckboxExclamation.2826fe6c.svg";
export { ForwardRef as ReactComponent };